__turbopack_context__.v({
  "modal": "login-module__KLvTmW__modal",
  "wrapper": "login-module__KLvTmW__wrapper",
});
